import { XMLParser } from 'fast-xml-parser';

// todo: change and adapt backgroundCheckUtils with CRMS-95

export enum ProductId {
    CriminalSuper = 'SUPERVAL',
    SsnVerification = 'SSNVER',
    SexOffender = 'NWSEXVAL',
    Ofac = 'OFAC',
    Super = 'SUPER',
}

export type ComponentEntity = {
    ProductId?: string;
    ProductName?: string;
    State?: string;
    County?: string;
    RecordFound?: string;
    DataFormat?: string;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    ResultXML?: any;
};

const xmlParser = (xml: string) => {
    const parser = new XMLParser();
    const result = parser.parse(xml);

    const xmlData = result?.xml?.URLSearchResponse;

    if (!xmlData) {
        throw new Error('No XML data available.');
    }

    const componentList = Array.isArray(xmlData.ComponentsList?.Component)
        ? xmlData.ComponentsList?.Component
        : [xmlData.ComponentsList?.Component];

    return componentList.filter(Boolean) as ComponentEntity[];
};

export function isSsnValid(xml: string): boolean {
    const components = xmlParser(xml);
    const ssnComponents = components.filter(({ ProductId: productId }) => productId === ProductId.SsnVerification);

    if (ssnComponents.length === 0) {
        return true;
    }

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return ssnComponents.some((component: any) => {
        const { ResultXML } = component;

        if (!ResultXML?.SSN?.response?.ssnvalidation?.ssnvalid) {
            return true;
        }

        const isSsnValid = ResultXML.SSN.response.ssnvalidation.ssnvalid;

        return isSsnValid.toLowerCase() === 'true';
    });
}

export function hasMatchResults(xml: string): boolean {
    const components = xmlParser(xml);

    return components.some((component) => {
        const { ResultXML, RecordFound, ProductId: productId } = component;

        if (typeof RecordFound === 'string' && RecordFound.toLowerCase() !== 'true') {
            return false;
        }

        if (productId === ProductId.CriminalSuper || productId === ProductId.Super) {
            if (ResultXML.Criminal.Person) {
                return true;
            }
        }

        if (productId === ProductId.SexOffender) {
            return true;
        }

        if (productId === ProductId.Ofac) {
            return true;
        }

        return false;
    });
}
